import { ReactComponent as Card1 } from 'assets/howWork/card1.svg'
import { ReactComponent as Card1Mob } from 'assets/howWork/card1_mob.svg'
import { ReactComponent as Card2 } from 'assets/howWork/card2.svg'
import { ReactComponent as Card2Mob } from 'assets/howWork/card2_mob.svg'
import { ReactComponent as Card3 } from 'assets/howWork/card3.svg'
import { ReactComponent as Card3Mob } from 'assets/howWork/card3_mob.svg'
import { ReactComponent as Card4 } from 'assets/howWork/card4.svg'
import { ReactComponent as Card4Mob } from 'assets/howWork/card4_mob.svg'
import { ReactComponent as Card5 } from 'assets/howWork/card5.svg'
import { ReactComponent as Card5Mob } from 'assets/howWork/card5_mob.svg'
import { ReactNode } from 'react'

export type HowWorkCardType = {
  pic: ReactNode
  num: number
  header: string
  text: string
}

export const howWorkMock: (HowWorkCardType & { picMob: ReactNode })[] = [
  {
    pic: <Card1 />,
    picMob: <Card1Mob />,
    num: 1,
    header: 'выберите тип изделия',
    text: 'Для начала выберите подходящую категорию из предлагаемого нами оборудования',
  },
  {
    pic: <Card2 />,
    picMob: <Card2Mob />,
    num: 2,
    header: 'Укажите параметры',
    text: 'Внесите примерные параметры изделия, чтобы мы подобрали подходящие вам опции',
  },
  {
    pic: <Card3 />,
    picMob: <Card3Mob />,
    num: 3,
    header: 'укажите адрес',
    text: 'Отметьте, куда нужно приехать нашим специалистам для консультации на месте',
  },
  {
    pic: <Card4 />,
    picMob: <Card4Mob />,
    num: 4,
    header: 'назначьте удобное время',
    text: 'Укажите, когда вам будет удобно провести встречу с нашими специалистами',
  },
  {
    pic: <Card5 />,
    picMob: <Card5Mob />,
    num: 5,
    header: 'подтвердите заказ',
    text: 'Проверьте информацию, отправьте заявку и отслеживайте процесс выполнения заказа',
  },
]
